const MIN_VIEW_MAPPING = {
	Month: "months",
	Week: "days",
	Day: "days",
};

export class BookingLongStay {
	/**
	 * @param {Object} opts
	 * @param {HTMLElement} opts.wrapper
	 * @param {BookingDialog} opts.booking_dialog
	 * @param {object} opts.params
	 * @param {number} opts.params.count
	 * @param {string} opts.params.type
	 */
	constructor(opts) {
		this.wrapper = opts.wrapper;
		this.booking_dialog = opts.booking_dialog;
		this.params = opts.params;
		Object.assign(this, opts);
		this.build();
	}

	build() {
		const initial_date = new URLSearchParams(location.search).get("date");
		const layout = new frappe.ui.Dialog({
			parent: this.wrapper,
			title: __("Long Stay"),
			size: "large",
			fields: [
				{
					fieldtype: "HTML",
					fieldname: "html",
				},
				{ fieldtype: "Column Break" },
				{
					fieldtype: "HTML",
					fieldname: "intro_html",
				},
				{
					fieldtype: "Data",
					fieldname: "start_date",
					label: __("Start Date"),
					read_only: 1,
					reqd: 1,
				},
				{
					fieldtype: "Data",
					fieldname: "end_date",
					label: __("End Date"),
					read_only: 1,
					reqd: 1,
				},
				{
					fieldtype: "Button",
					fieldname: "book_btn",
					label: __("Book Now", null, "Booking"),
					click: async () => {
						button.disabled = true;

						const start_date = layout.get_value("start_date");
						if (!start_date) {
							return frappe.throw(__("Please select a start date"));
						}

						if (frappe.session.user == "Guest") {
							window.location = `/login?redirect-to=${window.location.pathname}?date=${start_date}`;
							return;
						}

						try {
							await frappe.xcall(
								"webshop.webshop.shopping_cart.booking.book_long_slot",
								{
									...this.booking_dialog.get_booking_params(),
									count: this.params.count || 1,
									start_date: start_date,
									skip_cart: this.booking_dialog.skip_cart,
								}
							);
							if (this.booking_dialog.skip_cart) {
								window.location.href = "/bookings";
							} else {
								window.location.href = "/cart";
							}
						} catch (e) {
							frappe.msgprint({
								title: __("Error"),
								message: e.message,
								indicator: "red",
							});
						} finally {
							this.refresh();
							button.disabled = false;
						}
					},
				},
			],
		});
		this.layout = layout;

		const uom = this.booking_dialog.uom;
		const count = this.params.count || 1;

		// map: Month -> months, Week -> weeks
		const type = this.params.type || "Month";
		if (type === "error") {
			frappe.throw(__("Error") + "<br>Invalid type");
		}
		const view = MIN_VIEW_MAPPING[type];

		/** @type {HTMLElement} */
		const intro = layout.fields_dict.intro_html.wrapper;
		const introText = __(
			"Book {0}",
			[__(uom || "").toLocaleLowerCase()],
			"Booking"
		);
		intro.classList.add("font-weight-bold", "font-size-lg", "mb-3");
		intro.textContent = introText;

		/** @type {HTMLButtonElement} */
		const button = layout.fields_dict.book_btn.input;
		button.classList.remove("btn-default", "btn-xs");
		button.classList.add("btn-primary", "btn-md");

		const outField = layout.fields_dict.start_date.input;

		const $wrapper = $(layout.fields_dict.html.wrapper);
		$wrapper.css({
			display: "grid",
			"place-items": "center",
		});

		moment.updateLocale("en", {
			week: {
				dow: frappe.datetime.get_first_day_of_the_week_index(),
			},
		});

		function getRangeInfo(inDate, type = "week", count = 1) {
			const mo = moment(inDate).locale("en");
			const date = mo.format("YYYY-MM-DD");
			const start = mo.startOf(type).format("YYYY-MM-DD");
			let end = mo;
			end = end.endOf(type);
			for (let i = 0; i < count - 1; i++) {
				end = end.add(1, type).endOf(type);
			}
			end = end.format("YYYY-MM-DD");
			return { date, start, end };
		}

		function rangeContains({ start, end }, date) {
			const ymd = moment(date).format("YYYY-MM-DD");
			if (ymd >= start && ymd <= end) {
				if (ymd == start) {
					return "start";
				} else if (ymd == end) {
					return "end";
				}
				return "inside";
			}
		}

		this.datepicker = $wrapper
			.datepicker({
				language: frappe.boot.lang,
				autoClose: true,
				todayButton: true,
				dateFormat: "yyyy-mm-dd",

				selectOtherMonths: true,
				selectOtherYears: true,
				showOtherMonths: true,
				showOtherYears: true,

				altField: outField,
				altFieldDateFormat: "yyyy-mm-dd",

				minDate: new Date(),
				firstDay: frappe.datetime.get_first_day_of_the_week_index(),

				view: view,
				minView: view,

				onSelect: (date) => {
					button.disabled = false;

					if (!date) {
						layout.set_value("start_date", "");
						layout.set_value("end_date", "");
						return;
					}

					let first_day = date;
					let last_day = date;

					if (type === "Month" || type === "Week") {
						const week = getRangeInfo(date, type.toLowerCase(), count);
						first_day = week.start;
						last_day = week.end;
					} else {
						last_day = frappe.datetime.add_days(date, count - 1);
					}

					layout.set_value("start_date", first_day);
					layout.set_value("end_date", last_day);
				},

				onRenderCell: (date, cellType) => {
					if (type === "Week" && cellType === "day") {
						// Highlight selected week
						let selected = this.datepicker?.selectedDates?.[0];
						if (!selected) return;
						const week = getRangeInfo(selected, "week", count);
						const res = rangeContains(week, date);
						if (res) {
							const classes = `booking-picker--week booking-picker--${res}-of-week`;
							return { classes };
						}
					}
				},
			})
			.data("datepicker");

		if (initial_date) {
			this.datepicker.selectDate(moment(initial_date).toDate());
		}
		// layout.make();
		layout.refresh();
	}

	refresh() {
		this.layout?.refresh();
	}

	destroy() {
		this.wrapper.innerHTML = "";
	}
}
